import React from 'react';

interface Props extends PropsWithClassNameOptional {
  height?: number;
  width?: number;
}

export default function PartialCreditIcon({className, height = 20, width = 20}: Props) {
  return (
    <svg
      className={className}
      data-icon='partial-credit'
      width={width}
      height={height}
      viewBox='0 0 30 26'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9999 0C22.2073 0 28.0499 5.82029 28.0499 13C28.0499 20.1797 22.2073 26 14.9999 26C14.422 26 13.8535 25.9582 13.2954 25.8858L13.6124 23.4736C14.0654 23.5324 14.5285 23.5625 14.9999 23.5625C20.856 23.5625 25.6031 18.8336 25.6031 13C25.6031 7.16649 20.856 2.4375 14.9999 2.4375C14.5285 2.4375 14.0654 2.46753 13.6124 2.52637L13.2954 0.112671C13.8534 0.0401463 14.4221 0 14.9999 0Z'
        fill='currentColor'
      />
      <path
        d='M8.54661 21.3821C9.27685 21.9411 10.082 22.4073 10.9425 22.7627L10.0042 25.0114C8.94367 24.5731 7.95482 23.999 7.05713 23.3118L8.54661 21.3821Z'
        fill='currentColor'
      />
      <path
        d='M5.19982 17.0416C5.55664 17.8988 6.02465 18.7009 6.58575 19.4284L5.6156 20.1711L4.64704 20.9106C3.95738 20.0162 3.38064 19.0313 2.94092 17.9747L3.21014 17.8652L5.19982 17.0416Z'
        fill='currentColor'
      />
      <path
        d='M19.1163 8.84858C19.5802 8.4317 20.2823 8.46126 20.7603 8.93745C21.2191 9.39448 21.2191 10.1562 20.7603 10.6132L14.2354 17.1132C13.7573 17.5894 13.0553 17.619 12.5914 17.202L9.15044 13.7744C8.75975 13.3431 8.75975 12.7076 9.15044 12.2763L9.32886 12.0986C9.79276 11.6817 10.4948 11.7113 10.9729 12.1874L13.3687 14.5742L19.1163 8.84858Z'
        fill='currentColor'
      />
      <path
        d='M3.27399 11.4591L4.48628 11.6178C4.42722 12.0691 4.39707 12.5304 4.39707 13C4.39707 13.4696 4.42722 13.9309 4.48628 14.3822L3.27241 14.5393L3.27399 14.5409L2.06331 14.6964C1.99063 14.1411 1.9502 13.5751 1.9502 13C1.9502 12.4244 1.9905 11.8578 2.06331 11.302L3.27399 11.4591Z'
        fill='currentColor'
      />
      <path
        d='M6.58575 6.57142C6.02465 7.29887 5.55664 8.10097 5.19982 8.95814L2.94092 8.02344C3.38072 6.96706 3.95733 5.98187 4.64704 5.08765L6.58575 6.57142Z'
        fill='currentColor'
      />
      <path
        d='M10.9425 3.23731C10.082 3.59276 9.27685 4.05897 8.54661 4.61792L7.05713 2.68664C7.95479 1.99958 8.94377 1.42518 10.0042 0.987061L10.9425 3.23731Z'
        fill='currentColor'
      />
    </svg>
  );
}
